<simple-notifications id="notifications" [options]="simpleNotificationsOptions"></simple-notifications>
<router-outlet></router-outlet>
